export enum PaymentMethods {
  TEST = 'TEST',
  CASH = 'CASH',
  MIXED = 'MIXED',
  CARD = 'CARD',
  DELIVERY = 'DELIVERY',
  ONLINE = 'ONLINE',
  FREE = 'FREE',
  PROMOTION = 'PROMOTION',
}

export enum TypingModes {
  NORMAL = 'NORMAL',
  FRACTION = 'FRACTION'
}

export enum GroupTypes {
  REQUIRED = 'required',
  OPTIONAL = 'optional',
  ONE_OF = 'one_of'
}

export enum IngredientUnits {
  UNIT = 'UNIT',
  GRAM = 'GRAM',
  MILLILITER = 'MILLILITER'
}

export enum GridViews {
  ROW = 'ROW',
  TABLE = 'TABLE',
  CATEGORY = 'CATEGORY'
}

export enum StaffOrdersWrapperBackgroundClasses {
  BG_COLOR_WHITE = '-bg-color-white',
  BG_COLOR_GRAY = '-bg-color-gray',
  BG_COLOR_BLUE = '-bg-color-blue',
  BG_COLOR_GREEN = '-bg-color-green',
  BG_COLOR_BLUE2 = '-bg-color-blue2',
  BG_COLOR_ORANGE = '-bg-color-orange'
}

export enum PosWrapperBackgroundClasses {
  BG_COLOR_WHITE = '-bg-color-white',
  BG_COLOR_GRAY = '-bg-color-gray',
  BG_COLOR_BLUE = '-bg-color-blue',
  BG_COLOR_GREEN = '-bg-color-green',
  BG_COLOR_BLUE2 = '-bg-color-blue2',
  BG_COLOR_ORANGE = '-bg-color-orange'
}
